// extracted by mini-css-extract-plugin
module.exports = {"form":"ResetPassword_form__1QiTB"};